<template>
    <div>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickEdit(row)"
                    >编辑</Button
                >
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickDownload(row)"
                    >下载</Button
                >
            </template>
            <template v-slot:enabled="{ row }">
                <i-switch
                    v-model="row.enabled"
                    :disabled="!$can('update')"
                    size="large"
                    :true-value="1"
                    :false-value="0"
                    @on-change="toEnabled(row)"
                >
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                </i-switch>
            </template>
          <!--          是否默认-->
          <template v-slot:isDefault="{ row }">
            <i-switch
              v-model="row.isDefault"
              :disabled="!$can('update')"
              size="large"
              :true-value="1"
              :false-value="0"
              @on-change="toDefault(row)"
            >
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹层 -->
        <smart-modal
            v-model="modal.showTplForm"
            :title="actionTitle + '模板'"
            :width="600"
            :height="220"
            :maskClosable="false"
            @close-by-confirm="fetch"
        >
            <s-tpl-form
                v-if="modal.showTplForm"
                :id="curId"
                :form-mode="formMode"
            ></s-tpl-form>
        </smart-modal>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { mapCell } from '_c/grid/renderCell'
import { downLoadBlob } from '_u/helper'
import {
    contractTplList,
    contractTplEnable,
    contractTplDownload,
    updateDefault,
} from '@/api/configuration'
import Dict from '_u/dict'
import mList from '_v/common/m-list'
import STplForm from './s-tpl-form'

export default {
    name: 's-tpl-list',
    mixins: [mList],
    components: { STplForm },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            page: {
                total: 0,
                list: [],
            },
            dict: {
                contractTpl: Dict.NULL,
            },
            modal: {
                showTplForm: false,
            },
            curId: '',
        }
    },
    computed: {
        ...mapCache({
            filter: 'settingContracttpl',
        }),
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60,
                },
                {
                    key: 'tplName',
                    title: '模板名称',
                    align: 'left',
                    minWidth: 160,
                },
                {
                    key: 'tplType',
                    title: '模板类型',
                    align: 'left',
                    minWidth: 120,
                    render: mapCell(this.dict.contractTpl.toList()),
                },
                {
                    key: 'rentOverduePunishText',
                    title: '逾期罚款比例',
                    align: 'left',
                    minWidth: 120,
                },
                {
                    key: 'enabled',
                    title: '是否启用',
                    align: 'center',
                    width: 100,
                    slot: 'enabled',
                    fixed: 'right',
                },
              {
                key: 'isDefault',
                title: '是否默认',
                align: 'center',
                width: 100,
                slot: 'isDefault',
                fixed: 'right',
              },

                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 130,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                contractTplList(this.filter),
                Dict.get(['contract_tpl']),
            ])
                .then((args) => {
                    var [view, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    var pageData = view.data.page
                    this.page.list = this.normalizePageData(pageData.list)
                    this.page.total = parseInt(pageData.totalCount)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        normalizePageData(list) {
            list.forEach((v) => {
                v.rentOverduePunishText = v.rentOverduePunish * 100 + '%'
            })
            return list
        },
        // 下载
        rowClickDownload(row) {
            contractTplDownload(row.id).then((res) => {
                downLoadBlob(res, row.tplName)
                this.$Message.success('下载成功')
            })
        },
        // 编辑
        rowClickEdit(row) {
            this.formMode = this.FORM_MODE.update
            this.curId = row.id
            this.modal.showTplForm = true
        },
        toEnabled(row) {
            contractTplEnable(row.id)
                .then(() => {
                    this.$Message.success(this.$t('tips.update.success'))
                })
                .finally(() => this.fetch())
        },

        toDefault(row){
            updateDefault(row.id)
              .then(() => {
                this.$Message.success(this.$t('tips.update.success'))
              })
              .finally(() => this.fetch())
      }
    },
}
</script>
<style lang="less" scoped>
.radio {
    margin-left: 50px;
}
</style>
